import { AuthService } from '@ortho-next/auth-core';
import { AppConfig } from './core';


/**
* Authentication configuration for application.
*/
export function getAuthConfig(config: AppConfig) {
	return {
		allowedUrls: [
			config.domainUserAPI,
			config.domainAdminAPI,
			config.domainPatientAPI,
			config.domainImageAPI,
			config.domainRayAPI,
			config.domainIntegrationAPI,
			config.domainTlhexAPI,
			config.domainAiAPI
		],
		appSSOutUriApi: config.appSSOutUriApi,
		applicationScope: config.b2cApplicationScope,
		clientId: config.b2cClientId,
		idleTimeToEndSession: config.idleTimeToEndSession,
		tenantName: config.b2cTenantName,
		resetPasswordPolicyId: config.b2cResetPasswordPolicyId,
		signInPolicyId: config.b2cSignInPolicyId,
		changePasswordPolicyId: config.b2cChangePasswordPolicyId,
		showDebugInformation: config.envName !== 'production'
	};
}

export function initAuth(authSrv: AuthService) {
	return authSrv.runInitialLoginSequence();
}

export const DEFAULT_APP_VERSION = '2.1.0';